import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { StorageService } from '../services/storage.service';

export const guestGuard = () => {
  const router = inject(Router);
  const storageService = inject(StorageService);

  // Check if user is logged in by checking session storage
  const userInfo = storageService.getSessionStorage('user_info');
  const hasTenantCode = storageService.getSessionStorage('tenant_code') !== null &&
    storageService.getSessionStorage('tenant_code') !== '';
  const hasTenantId = storageService.getSessionStorage('tenant_id') !== null &&
    storageService.getSessionStorage('tenant_id') !== '';

  // Check for valid session
  const hasValidSession = userInfo && userInfo?.sessionId;

  // If user has all required session data, they are logged in
  if (hasValidSession && hasTenantCode && hasTenantId) {
    // User is logged in, redirect to home page
    router.navigate(['/home']);
    return false;
  }

  // User is not logged in, allow access to sign-in page
  return true;
};
